module.exports = __webpack_public_path__ + "media/images/pc/top/title-6f13c31bba9d7f441ae7e59601c8c99f.png";